var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 5.875C38.8663 5.875 30.9152 8.28692 24.1522 12.8058C17.3892 17.3247 12.1181 23.7475 9.00547 31.2621C5.89282 38.7768 5.07839 47.0454 6.66523 55.0229C8.25202 63.0004 12.1688 70.3285 17.9202 76.0797C23.6717 81.8313 30.9995 85.748 38.9769 87.3346C46.9546 88.9217 55.2234 88.1074 62.738 84.9944C70.2525 81.8818 76.6754 76.6108 81.1941 69.8479C85.7131 63.085 88.125 55.1337 88.125 47C88.125 36.093 83.7924 25.6327 76.0797 17.9202C68.3674 10.2078 57.9071 5.875 47 5.875ZM41.125 63.423L26.4375 48.7355L31.1099 44.0625L41.125 54.077L62.8919 32.3125L67.5793 36.9711L41.125 63.423Z",
    fill: "#16A34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.6fcf423b22e7f6eb5cbb3658fd487d39.svg";
export { ForwardRef as ReactComponent };